// src/components/Activities/InvitedHeads.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Activities.css';

const InvitedHeads = () => {
  return (
    <div className="activity-page">
      <div className="activity-hero">
        <div className="activity-hero-overlay"></div>
        <div className="activity-hero-content">
          <span className="activity-hero-badge">VIPs</span>
          <h1>Invited Heads & VIPs</h1>
        </div>
      </div>
      <div className="activity-container">
        <div className="activity-content-placeholder">
          <h3>Coming Soon</h3>
          <p>List of invited heads of state, government officials, and VIPs will be available shortly.</p>
        </div>
        <div className="activity-back">
          <Link to="/activities" className="back-button">← Back to Activities</Link>
        </div>
      </div>
    </div>
  );
};

export default InvitedHeads;
